import { QuestTracker } from '@slimebound/core';

export interface QuestHUDOptions {
  containerElement?: HTMLElement | null;
}

export class QuestHUD {
  private tracker: QuestTracker;
  private container: HTMLElement | null = null;

  constructor(tracker: QuestTracker, options: QuestHUDOptions = {}) {
    this.tracker = tracker;
    if (options.containerElement !== undefined) {
      this.container = options.containerElement;
    } else if (typeof document !== 'undefined') {
      this.container = document.getElementById('hud-quest-container');
    }

    this.tracker.onQuestCompleted(() => {
      this.render();
    });

    this.tracker.onVictory(() => {
      this.render();
    });
  }

  public render(): void {
    if (!this.container) return;

    const active = this.tracker.getActiveQuest();
    if (!active) {
      this.container.innerHTML = `
        <div class="quest-card quest-card-complete">
          <div class="quest-badge">🏆 Vertical Slice Complete!</div>
          <div class="quest-title">Master of the Primordial Realm</div>
          <div class="quest-desc">You have explored, evolved, built, tamed, and slain the Dungeon Titan!</div>
        </div>
      `;
      return;
    }

    const progressPercent = Math.min(100, Math.round((active.currentCount / active.targetCount) * 100));

    this.container.innerHTML = `
      <div class="quest-card">
        <div class="quest-badge">📜 CURRENT QUEST</div>
        <div class="quest-title">${active.title}</div>
        <div class="quest-desc">${active.description}</div>
        <div class="quest-progress-bar">
          <div class="quest-progress-fill" style="width: ${progressPercent}%;"></div>
        </div>
        <div class="quest-progress-text">${Math.min(active.currentCount, active.targetCount)} / ${active.targetCount} (${progressPercent}%)</div>
      </div>
    `;
  }
}
